export default "__VITE_ASSET__CtyYY3xd__"